import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import { I18n } from 'react-redux-i18n';

export default function NewModal({
  open,
  steps = [],
  onClose,
  customStyle,
  onFinish,
  defaultStep = 0,
  hideFooter = false,
  hideCloseButton = false,
}) {
  const [step, setStep] = useState(defaultStep ? parseInt(defaultStep) : 0);
  const [direction, setDirection] = useState('next'); // next | prev
  const modalRef = useRef(null);
  const touchStartX = useRef(0);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
      if (e.key === 'ArrowRight' && step < steps.length - 1) goNext();
      if (e.key === 'ArrowLeft' && step > 0) goPrev();
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [step]);

  const goNext = () => {
    setDirection('next');
    setStep((s) => Math.min(s + 1, steps.length - 1));
  };

  const goPrev = () => {
    setDirection('prev');
    setStep((s) => Math.max(s - 1, 0));
  };

  const handleOverlayClick = (e) => {
    if (!modalRef.current.contains(e.target)) {
      // onClose?.();
    }
  };

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) < 50) return;

    if (diff > 0 && step < steps.length - 1) goNext();
    if (diff < 0 && step > 0) goPrev();
  };

  if (!open) return null;

  return (
    <div
      className={`cc-overlay ${open ? 'open' : ''}`}
      onMouseDown={handleOverlayClick}
    >
      <div
        className="cc-modal"
        ref={modalRef}
        onMouseDown={(e) => e.stopPropagation()}
        style={customStyle}
      >
        <div className={`cc-header ${hideFooter ? 'cc-header--no-progress' : ''}`}>
          {!hideFooter && (
            <div className="cc-progress">
              <div
                className="cc-progress__fill"
                style={{ width: `${((step + 1) / steps.length) * 100}%` }}
              />
            </div>
          )}
          {!hideCloseButton && <div className="cc-header-close">
            <button className="cc-close" onClick={onClose}>
                ✕
              </button>
            </div>
          }
        </div>
        <div
          className="cc-body"
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          <div
            className={`cc-slider ${direction}`}
            style={{ transform: `translateX(-${step * 100}%)` }}
          >
            {steps.map((StepComponent, index) => (
              <div className="cc-slide" key={index}>
                {StepComponent}
              </div>
            ))}
          </div>
        </div>

        {!hideFooter && (
          <div className="cc-footer">
            <div className="cc-dots">
              {steps.map((_, i) => (
                <span
                  key={i}
                  className={i === step ? 'active' : ''}
                  onClick={() => {
                    setDirection(i > step ? 'next' : 'prev');
                    setStep(i);
                  }}
                />
              ))}
            </div>

            <div className="cc-actions">
              {step < steps.length - 1 ? (
                <button className="cc-next" onClick={goNext}>
                  <span>Next</span>
                  <div className="cc-next-chevron" />
                </button>
              ) : (
                <button
                  className="cc-finish"
                  onClick={() => {
                    onFinish?.();
                    setStep(0);
                  }}
                >
                  <span>{I18n.t('welcome.getStarted')}</span>
                  <div className="cc-check-icon">✓</div>
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
